





























import { Vue, Component } from "../vue-ext";
import { Request } from "../models";

@Component
export default class RequestsView extends Vue {
    private requests: Request[] = [];
    private page: number = 1;
    private pageSize: number = 10;
    private lastPage: number = 1;

    private async created() {
        this.root.setTitle(this.$t("menu.requests") as string);
        this.root.setIconClass("icon-email");

        this.requests = this.root.requests;

        this.lastPage = Math.ceil(this.requests.length / this.pageSize);
        this.page = 1;
    }

    private next() {
        if (this.page < this.lastPage) {
            this.page = this.page + 1;
        }
    }

    private previous() {
        if (this.page > 1) {
            this.page = this.page - 1;
        }
    }

     private filteredRequests() {
        let filteredRequests = this.requests //this.search ? this.messages.filter(m => m.topic.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) : this.messages;
        this.lastPage = Math.ceil(filteredRequests.length / this.pageSize);

        if (this.page > this.lastPage) {
            this.page = this.lastPage;
        }

        return filteredRequests.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }
}
